module.exports = __webpack_public_path__ + "img/CS26Q-中_06.4c9286e4.jpg";